export enum ResponseItemStatus {
  None = 0,
  Open = 1,
  Closed = 2,
  Cancel = 3,
  Rejected = 4,
}
